import * as Global from 'styles/global/global.styles';
import { zIndex } from '../global/global.styles';

export {};

export function background() {
	return {
		position: 'absolute',
		opacity: '3%',
		maxWidth: '100%',
		height: { xs: '50vh', sm: '70vh', lg: Global.viewport().height },
		width: 'auto',
		left: '0',
		top: '0',
		right: '0',
		bottom: '0',
		m: 'auto',
		zIndex: '0',
		display: { xs: 'block', sm: 'block' },
	};
}

export function container() {
	return {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'nowrap',
		minHeight: Global.viewport().height,
		// py: '20px',
		p: '0',
		m: 'auto',
		alignItems: 'center',
		overflow: 'hidden',
		// This is needed for out of screen content when rotating a phone for example
		overflowY: 'auto'
	};
}
